<template>
  <section>
    <form
      class="form-control"
      :class="{ 'form-control--flex': isFormFlex }"
      @submit.prevent="$emit('submit')"
    >
      <div
        v-for="item in fields"
        :key="item.key"
        class="form-control__item"
        :form-control-for="item.key"
      >
        <template v-if="!(item.hideIf && item.hideIf())">
          <form-field-renderer
            :item="item"
            :fields="fields"
            @invalidForm="invalidForm"
            @validForm="validForm"
          />
        </template>
      </div>
    </form>
  </section>
</template>

<script>
import FormFieldRenderer from "@/components/FormFieldRenderer.vue";
import { computed } from "@vue/composition-api";

export default {
  props: ["page"],
  components: {
    FormFieldRenderer,
  },
  methods: {
    invalidForm() {
      this.$emit("invalidForm");
    },
    validForm() {
      this.$emit("validForm");
    },
  },
  setup(props) {
    const dateConfig = {
      altInput: true,
      altFormat: "J M Y",
      dateFormat: "Y-m-dT00:00:00\\Z",
      placeholder: "e.g. DD/MM/YYYY",
    };

    const isFormFlex = computed(() => {
      if (props.page.isFormFlex !== undefined) return props.page.isFormFlex;
      else false;
    });

    const { fields } = props.page;

    fields.forEach((f) => {
      if (!f.maxlength) f.maxlength = 75;

      f.rules = f.rules || [];
      f.validation = f.rules.join("|");
      if (f.rules.includes("required")) f.required = true;
      if (f.type === "date") {
        f.dateConfig = {
          ...dateConfig,
          ...(f.dateConfig || {}),
        };
      }
    });

    return {
      fields,
      isFormFlex,
    };
  },
};
</script>

<style lang="scss">
@import "../styles/global-variables";
.personal-email-box {
  padding: 1em;
  background-color: var(--primary);
  color: #ffffff;
  border-radius: 4px;
  margin-bottom: 1.125em;
  line-height: 1.5;
}

.validation-label {
  color: var(--error);
  display: block;
  font-size: 14px;
  margin: 8px 0;

  span {
    color: var(--error);
  }
}
.form-control-item {
  margin-bottom: 16px;
  .form-control-item__group {
    margin-bottom: 16px;
  }
  label {
    font-size: 14px;
    line-height: 16px;
  }
  input,
  label {
    display: block;
  }
  input,
  textarea {
    background-color: var(--white);
    border: 1px solid var(--mid-grey);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px 16px;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    height: unset;

    &:focus {
      border: 1px solid var(--primary);
    }

    &.has-errors,
    &.touched.invalid {
      border-color: var(--error);
    }
  }
  label {
    margin-bottom: 16px;
  }
}

.form-control-item.form-control-item--checkbox {
  position: relative;

  input {
    left: -999999px;
    position: absolute;
  }

  label {
    align-items: center;
    display: flex;
    height: 24px;
    margin-bottom: 0;
    padding-left: 48px;
    position: relative;

    &::before {
      border: 1px solid var(--primary);
      border-radius: 3px;
      box-sizing: border-box;
      content: "";
      height: 24px;
      left: 0;
      position: absolute;
      transition: 0.2s ease;
      width: 24px;
    }

    &::after {
      background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNTA0LjUwMiA3NS40OTZjLTkuOTk3LTkuOTk4LTI2LjIwNS05Ljk5OC0zNi4yMDQgMEwxNjEuNTk0IDM4Mi4yMDMgNDMuNzAyIDI2NC4zMTFjLTkuOTk3LTkuOTk4LTI2LjIwNS05Ljk5Ny0zNi4yMDQgMC05Ljk5OCA5Ljk5Ny05Ljk5OCAyNi4yMDUgMCAzNi4yMDNsMTM1Ljk5NCAxMzUuOTkyYzkuOTk0IDkuOTk3IDI2LjIxNCA5Ljk5IDM2LjIwNCAwTDUwNC41MDIgMTExLjdjOS45OTgtOS45OTcgOS45OTctMjYuMjA2IDAtMzYuMjA0eiIvPjwvc3ZnPg==");
      background-repeat: no-repeat;
      background-size: 60%;
      background-position: center center;
      border: 1px solid transparent;
      border-radius: 3px;
      box-sizing: border-box;
      content: "";
      height: 24px;
      left: 0;
      opacity: 0;
      position: absolute;
      transition: 0.4s ease;
      width: 24px;
    }

    &.label-wrapper {
      margin-bottom: 8px;
      padding-left: 0;

      &::before,
      &::after {
        display: none;
      }
    }
  }

  input:checked ~ label {
    &::before {
      background-color: var(--primary);
    }
    &::after {
      opacity: 1;
    }
  }
}

.mobile-phone {
  font-size: 14px;
}

.form-control-item.form-control-item--radio {
  position: relative;
  input {
    left: -999999px;
    position: absolute;
  }
  label {
    align-items: center;
    display: flex;
    height: 24px;
    margin-bottom: 0;
    padding-left: 48px;
    position: relative;
    &::before {
      border: 1px solid var(--primary);
      border-radius: 50%;
      box-sizing: border-box;
      content: "";
      height: 24px;
      left: 0;
      position: absolute;
      transition: 0.2s ease;
      top: 0;
      width: 24px;
    }
    &::after {
      background-color: var(--primary);
      border: 1px solid transparent;
      border-radius: 50%;
      box-sizing: border-box;
      content: "";
      height: 16px;
      left: 4px;
      opacity: 0;
      position: absolute;
      transition: 0.4s ease;
      top: 4px;
      width: 16px;
    }
    &.label-wrapper {
      margin-bottom: 8px;
      padding-left: 0;
      &::before,
      &::after {
        display: none;
      }
    }
  }
  input:checked ~ label {
    &::after {
      opacity: 1;
    }
  }
}

.form-control-item.form-control-item--datepicker {
  width: calc(50% - 16px);

  @media all and (min-width: 1200px) {
    width: 100%;
  }
}

.password-control {
  margin-bottom: 16px;
}

.select-box {
  position: relative;

  select {
    background-color: #ffffff;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACUSURBVHgBfY4hDgIxEEV3OoeoaMUeYUV7ACSSI/RkK5GVBEWQKJBIVMMdmjb8LzbZANlvZjLz/p/REMLdOXcrpbyHDU0QuJMRkdR7zzHGaQs2xuTWWlIme++vMM2oP5cWGPvDA1IOCVlrz7h2XJsIq+oMeA/2yZl8pY0AMhJTrXUgjDeY/FoY+fPvCMOFPZJ3a5j6AE/OTImRcXvEAAAAAElFTkSuQmCC");
    background-repeat: no-repeat;
    background-position: 95% 50%;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 4px;
    border: 1px solid var(--mid-grey);
    padding: 10px 16px;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    height: unset;

    &.has-errors,
    &.invalid.touched {
      border-color: var(--error);
    }
  }
}

input[type="date"] {
  background-color: #ffffff;
  background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+);
  background-repeat: no-repeat;
  background-position: 95% 50%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

select {
  display: inline-block;
}

.date-input {
  min-width: 95%;
}

.form-control {
  &--flex {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: -16px;

    .form-control__item {
      margin-left: 16px;
    }
  }

  &__item {
    &[form-control-for="title"] {
      width: 30%;
      margin-right: calc(70% - 16px);
    }

    &[form-control-for="firstName"],
    &[form-control-for="lastName"] {
      width: calc(50% - 16px);
    }

    &[form-control-for="dateOfBirth"],
    &[form-control-for="startDate"],
    &[form-control-for="university"],
    &[form-control-for="course"],
    &[form-control-for="homeAddress"],
    &[form-control-for="mobilePhone"],
    &[form-control-for="yearOfStudy"],
    &[form-control-for="lengthOfCourse"],
    &[form-control-for="qualificationOnEntry"],
    &[form-control-for="fullPartTime"] {
      width: 100%;
    }
  }
}
</style>
